export default __webpack_public_path__ + "static/media/product-collect-saliva.0da895bb.svg";